<template>
	<v-dialog v-model="dialog" max-width="600px">

		<v-card  class="dialog-toolbardomaindetail">
			<v-card-title>
				<span class="headline">{{ domain }}</span>
			</v-card-title>
			<v-card-text>

				<AuthViewForDomains v-if="dialog" :domain="this.domain" /> 

			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1" flat @click="dialog = false">Tamam</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>


<script>
	import AuthViewForDomains from "@/components/tools/AuthViewForDomains"
	export default {
		name: "ToolbarDomainDetail",
		components:{
			AuthViewForDomains
		},
		props:{
			show : Boolean,
			domain : String
		},
		data: () => ({
			dialog: false,
			loaded: false,
			detail : {
				auths : []
			}
		}),
		watch : {
			show(n,o){
				this.dialog = n ? true : false;
				if(!o && n){
					this.loadDetails()
				}
			},
			dialog(v){
				if(!this.dialog){
					this.$emit("DomainSearchDialogClose",false);
					this.loaded = false;
				}
			}
		},
		methods:{
			loadDetails(){
				this.loaded = false; 
				this.$http.get( process.env.VUE_APP_API_URL + "/web/toolbar/domain/", {
					params : {
						domain : this.domain
					}
				}).then(response => {  
					this.detail = response.body;
					this.loaded = true; 
				}) 
			},
			copyThis(e){

			},
			connectFtp(){
				window.open(process.env.VUE_APP_API_URL + "/web/connect/ftp/?method=default&link=http://"+this.domain, "_blank");  
			},
			connectNetmin(){
				window.open(process.env.VUE_APP_API_URL + "/web/connect/netmin/?method=default&link=http://"+this.domain, "_blank");  
			}
		}
	}
</script> 

<style lang="less"  >
.dialog-toolbardomaindetail{
	.list-auths{
		.v-list__tile{
			height: auto !important; 
			padding-top:2px;
			padding-bottom:2px;
		}
		.v-list__tile__title{
			color : #bbb;
			font-size:14px;
			font-style: italic;
		}

		.btn-auth{ 
			margin-right:5px;
			width:120px;
			font-size:11px;
		} 
		.btn-auth-action{ 
			min-width:40px; 
			box-shadow: none !important;
			.v-icon{ 
				font-size:18px;
			}
		}
	}
	.ToolbarSDDUsername,
	.ToolbarSDDPassword{

	}
}
</style>
